// add to it if needed
// https://de.wikipedia.org/wiki/Artikel_(Wortart)
// https://de.wikipedia.org/wiki/Demonstrativpronomen

export const subjectGenus: SubjectGenus = {
    masculine: {
        articleNominativeSingular: 'der',
        articleGenitiveSingular: 'des',
        articleDativeSingular: 'dem',
        articleAccusativeSingular: 'den',
        demonstrativePronounNominativ: 'dieser',
        demonstrativePronounDative: 'diesem',
        demonstrativePronounAccusative: 'diesen',
        countableNoun: 'ein',
    },
    feminine: {
        articleNominativeSingular: 'die',
        articleGenitiveSingular: 'der',
        articleDativeSingular: 'der',
        articleAccusativeSingular: 'die',
        demonstrativePronounNominativ: 'diese',
        demonstrativePronounDative: 'dieser',
        demonstrativePronounAccusative: 'diese',
        countableNoun: 'eine',
    },
    neuter: {
        articleNominativeSingular: 'das',
        articleGenitiveSingular: 'des',
        articleDativeSingular: 'dem',
        articleAccusativeSingular: 'das',
        demonstrativePronounNominativ: 'dieses',
        demonstrativePronounDative: 'diesem',
        demonstrativePronounAccusative: 'dieses',
        countableNoun: 'ein',
    },
};